import { AnnotationConstant } from "Constants/AnnotationConstants";
import AppColorStore from "Stores/AppColor/AppColorStore";
import { ChannelLineControl } from '../Presentational/index';
import { connect } from 'react-redux';
import {
    handleDragStart, handleDragMove, handleDragEnd, handleDeleteAnnotationDrawing, handleToggleContextMenu,
    handleAnchorDragStart, handleAnchorDragEnd, handleAnchorDragMove
} from '../../../../../../Actions/AnnotationActions';
import React, { Component } from 'react';
const { ActionTypes } = AnnotationConstant;

class GraphicsChannelLine extends Component {

    componentDidMount() {
        AppColorStore.addChangeListener(this.AppColorStoreStateChanged);
    }

    componentWillUnmount() {
        AppColorStore.removeChangeListener(this.AppColorStoreStateChanged);
    }

    AppColorStoreStateChanged = () => {

        this.forceUpdate();
    }

    render() {
        const { channelLine, index, lockImage, isApiReqResolved } = this.props;
        const { isDragging, activeAnchor, selectedAnnotId } = this.props.annotationChartModelReducer;

        return (

            <ChannelLineControl
                key={index}
                index={index}
                channelLine={channelLine}
                isDragging={isDragging}
                activeAnchor={activeAnchor}
                selectedAnnotId={selectedAnnotId}
                handleDragStart={this.props.handleDragStart}
                handleDragMove={this.props.handleDragMove}
                handleDragEnd={this.props.handleDragEnd}
                handleAnchorDragStart={this.props.handleAnchorDragStart}
                handleAnchorDragEnd={this.props.handleAnchorDragEnd}
                handleAnchorDragMove={this.props.handleAnchorDragMove}
                onContextMenu={this.props.onContextMenu}
                draggable={this.props.draggable}
                lockImage={lockImage}
                isApiReqResolved={isApiReqResolved}
                handleDeleteAnnotationDrawing={this.props.handleDeleteAnnotationDrawing}
            />
        );
    }
}

const mapStateToProps = ({ annotationReducers }) => {
    const { channelLineReducer, annotationChartModelReducer } = annotationReducers;
    return ({ channelLineReducer, annotationChartModelReducer });
}

const mapDispatchToProps = (dispatch) => ({
    handleDragStart: (channelLine) => dispatch(handleDragStart(channelLine)),
    handleDragMove: (e, isEndExtend) => dispatch(handleDragMove(e, isEndExtend)),
    handleDragEnd: () => handleDragEnd(),
    handleAnchorDragStart: (anchor) => dispatch(handleAnchorDragStart(anchor)),
    handleAnchorDragEnd: () => handleAnchorDragEnd(),
    handleAnchorDragMove: (e) => dispatch(handleAnchorDragMove(e, ActionTypes.HANDLE_CHANNEL_LINE_DRAW)),
    handleDeleteAnnotationDrawing: (charCode) => { dispatch(handleDeleteAnnotationDrawing(charCode)), dispatch(handleToggleContextMenu(false, 0, 0, '')) }
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphicsChannelLine);